import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import NewArrivalsServices from '../api/NewArrivalsServices';

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const retrieveNewArrivalsServices = createAsyncThunk('newArrival-getAll', async () => {
  try {
    const res = await NewArrivalsServices.getAll();
    return res.data.data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
});

const newArrivalsSlice = createSlice({
  name: 'newArrival',
  initialState,
  extraReducers: {
    [retrieveNewArrivalsServices.pending]: (state) => {
      state.loading = true;
    },
    [retrieveNewArrivalsServices.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    [retrieveNewArrivalsServices.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const selectAllData = (state) => state.newArrivals.data;
export const getStatusMessage = (state) => state.newArrivals.status;
export const getErrorMessage = (state) => state.newArrivals.error;

export default newArrivalsSlice.reducer;
